import { observable } from "mobx";
import { IService, IComponent } from "../_types/interfaces";
import i18n from 'i18next';
import { updateComponent } from "../_services";

const translate = (name: string) => i18n.t('components.notification.' + name);

export const componentStore = observable({
    loading: false,
    uriService: "",
    services: [] as Array<IComponent>,
    installService: [] as Array<IComponent>,
    plugins: [] as Array<IComponent>,
    installPlugins: [] as Array<IComponent>,
    isNotification: false,
    message: "",
    showMessage(message: string) {
        this.message = message;
        this.isNotification = true;
    },
    async getAddress() {
        this.loading = true;
        try {
            const response = await updateComponent.getAddress();
            this.uriService = response;
        }
        catch (errors) {
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
    async loadServices() {
        this.loading = true;
        try {
            const responseGetServices = 
                await updateComponent.getServices(componentStore.uriService);
            this.services = responseGetServices;
            const responseGetInstallServices = 
                await updateComponent.getInstallServices();
            this.installService = responseGetInstallServices;
        }
        catch (errors) {
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
    async loadPlugins() {
        this.loading = true;
        try {
            const responseGetPlugins = 
                await updateComponent.getPlugins(this.uriService);
            this.plugins = responseGetPlugins;
            const responseGetInstallPlugins = 
                await updateComponent.getInstallPlugins();
            this.installPlugins = responseGetInstallPlugins;
        }
        catch (errors) {
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
    async addComponents(names: Array<string>) {
        this.loading = true;
        try {
            await updateComponent.updateServices(names);
            this.showMessage(translate('add_ok'));
        }
        catch (errors) {
            console.log(errors);
            this.showMessage(translate('add_error'));
        }
        this.loading = false;
    },

    async deleteComponents(names: Array<string>) {
        this.loading = true;
        try {
            await updateComponent.deleteServices(names);
            this.showMessage(translate('delete_ok'));
        }
        catch (errors) {
            console.log(errors);
            this.showMessage(translate('delete_error'));
        }
        this.loading = false;
    },
});